import type { HierarchySpec } from './hierarchy.js';

/**
 * Biological classification of the grey wolf. Every rank, member and excluded
 * sibling below is a real taxon at that rank: the exclusions are the point —
 * each step inward abandons a whole branch of life.
 */
export function hierarchyFixture(width = 640, focusRankId?: string): HierarchySpec {
  return {
    id: 'grey-wolf-classification',
    family: 'primitive-hierarchy',
    view: 'schematic',
    viewport: { width, height: width <= 340 ? 440 : width <= 450 ? 470 : 460 },
    subject: 'Grey wolf',
    title: 'Classification is containment, not resemblance',
    subtitle: 'Each rank encloses the next entirely, and every step inward leaves a real sibling group behind.',
    ranks: [
      { id: 'domain', rank: 'Domain', label: 'Eukaryota', detail: 'nucleated cells', excludes: 'Bacteria' },
      { id: 'kingdom', rank: 'Kingdom', label: 'Animalia', detail: 'multicellular', excludes: 'Plantae' },
      { id: 'phylum', rank: 'Phylum', label: 'Chordata', detail: 'notochord', excludes: 'Arthropoda' },
      { id: 'class', rank: 'Class', label: 'Mammalia', detail: 'milk, hair', excludes: 'Aves' },
      { id: 'order', rank: 'Order', label: 'Carnivora', detail: 'carnassial teeth', excludes: 'Primates' },
      { id: 'family', rank: 'Family', label: 'Canidae', detail: 'dogs', excludes: 'Felidae' },
      { id: 'genus', rank: 'Genus', label: 'Canis', detail: 'wolves', excludes: 'Vulpes' },
      { id: 'species', rank: 'Species', label: 'Canis lupus', detail: 'grey wolf', excludes: 'Canis latrans' },
    ],
    ...(focusRankId ? { focusRankId } : {}),
    provenance: 'Linnaean classification of Canis lupus (Linnaeus, 1758); excluded siblings are real taxa at the same rank',
  };
}
